import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Input from "../shared/Input";
import SelectDropdown from "../shared/SelectDropdown";
import { fetchData, fetchFormData, getValueLabel } from "../../utils/options";
import topTost from "../../utils/topTost";

const Loan_SchemesCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [LoanTypedata, setLoanTypeData] = useState([]);
  const [formData, setFormData] = useState({
    loan_type_id: "",
    scheme_name: "",
    interest_rate: "",
    tenure_months: "",
    processing_fee: "",
    prepayment_allowed: false,
    scheme_description: "",
    created_by: "",
    status: true,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);
  const Id = localStorage.getItem("id");
  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const fetchAllData = async () => {
    const result = await fetchData("list-loan-types", {}, "GET");
    if (result) {
      const loantypes = result.data || [];
      setLoanTypeData(getValueLabel(loantypes, "loan_type_name", "id") || []);
    }
  };

  const handleLoanTypeChange = (selected) => {
    console.log(selected);
    setFormData((prev) => ({
      ...prev,
      loan_type_id: selected?.value || "",
    }));
  };

  const fetchUserDetails = async (id) => {
    try {
      const result = await fetchData(`loan-schemes/${id}`, {}, "GET");

      if (result && result.data) {
        setFormData(result.data);
      } else {
        console.warn("User data not found.");
        setFormData("");
      }
    } catch (error) {
      console.error("Failed to fetch user details:", error);
      setFormData("");
    }
  };

  useEffect(() => {
    fetchAllData();

    if (id) {
      fetchUserDetails(id);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const form = new FormData();
      form.append("loan_type_id", formData.loan_type_id || 0);
      form.append("scheme_name", formData.scheme_name);
      form.append("interest_rate", formData.interest_rate);
      form.append("tenure_months", formData.tenure_months);
      form.append("processing_fee", formData.processing_fee);
      form.append("prepayment_allowed", formData.prepayment_allowed ? 1 : 0);
      form.append("scheme_description", formData.scheme_description);
      form.append("created_by", Id || 1);
      form.append("status", 1);

      let response;

      if (id) {
        form.append("id", id);
        // Edit existing scheme
        response = await fetchFormData("update-loan-schemes", form, "POST");
        navigate("/Loan/loan-schemes-list");
      } else {
        // Create new scheme
        response = await fetchFormData("add-loan-schemes", form, "POST");
        navigate("/Loan/loan-schemes-list");
      }
      console.log(response);
      if (response && response.message === "Loan scheme added successfully") {
        topTost({
          title: id
            ? "Scheme updated successfully"
            : "Scheme added successfully",
          icon: "success",
        });
      } else if (response && response.code === 422) {
        topTost({
          title: Array.isArray(response.message)
            ? response.message[0]
            : response.message || "Validation error",
          icon: "error",
        });
      } else {
        topTost({
          title: response?.message || "Operation failed",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Submit error:", error);
      topTost({
        title: "Unexpected error occurred",
        icon: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-5 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                <span className="d-block mb-2">
                  {id ? "Edit Loan Schemes:" : "Add Loan Schemes:"}
                </span>
              </h5>
            </div>
            <form onSubmit={handleSubmit} className="row g-3">
              <div className="row mb-4 align-items-center">
                <div className="col-lg-2">
                  <label className="fw-semibold">Loan Type: </label>
                </div>
                <div className="col-lg-4">
                  <SelectDropdown
                    options={LoanTypedata}
                    selectedOption={
                      LoanTypedata.find(
                        (opt) => opt.value === Number(formData.loan_type_id)
                      ) || null
                    }
                    defaultSelect={"Select Loan Type"}
                    onSelectOption={handleLoanTypeChange}
                    value={formData.loan_type_id}
                    icon="feather-credit-card"
                  />
                </div>
                <div className="col-lg-6">
                  <Input
                    label="Prepayment Allowed"
                    name="prepayment_allowed"
                    type="checkbox"
                    value={formData.prepayment_allowed}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Scheme Name and Interest Rate */}
              <div className="row mb-4">
                <div className="col-lg-6">
                  <Input
                    label="Scheme Name"
                    name="scheme_name"
                    value={formData.scheme_name}
                    onChange={handleChange}
                    placeholder="Scheme Name"
                    icon="feather-file-text"
                  />
                </div>
                <div className="col-lg-6">
                  <Input
                    label="Interest Rate (%)"
                    name="interest_rate"
                    value={formData.interest_rate}
                    onChange={handleChange}
                    placeholder="Interest Rate"
                    icon="feather-percent"
                  />
                </div>
              </div>

              {/* Tenure (Months) and Processing Fee */}
              <div className="row mb-4">
                <div className="col-lg-6">
                  <Input
                    label="Tenure (Months)"
                    name="tenure_months"
                    value={formData.tenure_months}
                    onChange={handleChange}
                    placeholder="Tenure in months"
                    icon="feather-calendar"
                  />
                </div>
                <div className="col-lg-6">
                  <Input
                    label="Processing Fee"
                    name="processing_fee"
                    value={formData.processing_fee}
                    onChange={handleChange}
                    placeholder="Processing Fee"
                    icon="feather-dollar-sign"
                  />
                </div>
              </div>

              {/* Scheme Description and Prepayment Allowed */}
              <div className="row mb-4">
                <div className="col-lg-6">
                  <Input
                    label="Scheme Description"
                    name="scheme_description"
                    value={formData.scheme_description}
                    onChange={handleChange}
                    placeholder="Describe the scheme"
                    icon="feather-align-left"
                  />
                </div>
              </div>

              <div className="mt-5 customButton">
                <button
                  type="submit"
                  className="btn btn-lg btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                </button>
              </div>
            </form>

            {/*                         <form onSubmit={handleSubmit} className="row g-3">

                            <div className="row mb-4 align-items-center">
                                <div className="col-lg-2">
                                    <label className="fw-semibold">Loan Type: </label>
                                </div>
                                <div className="col-lg-4">
                                    <SelectDropdown
                                        options={LoanTypedata}
                                        selectedOption={LoanTypedata.find(opt => opt.value === Number(formData.loan_type_id)) || null}
                                        defaultSelect={"Select Loan Type"}
                                        onSelectOption={handleLoanTypeChange}
                                    />
                                </div>
                            </div>

                            <Input
                                label="Scheme Name"
                                name="scheme_name"
                                value={formData.scheme_name}
                                onChange={handleChange}

                                placeholder="Scheme Name"
                                icon="feather-file-text"
                            />

                            <Input
                                label="Interest Rate (%)"
                                name="interest_rate"
                                value={formData.interest_rate}
                                onChange={handleChange}

                                placeholder="Interest Rate"
                                icon="feather-percent"
                            />

                            <Input
                                label="Tenure (Months)"
                                name="tenure_months"
                                value={formData.tenure_months}
                                onChange={handleChange}

                                placeholder="Tenure in months"
                                icon="feather-calendar"
                            />

                            <Input
                                label="Processing Fee"
                                name="processing_fee"
                                value={formData.processing_fee}
                                onChange={handleChange}

                                placeholder="Processing Fee"
                                icon="feather-dollar-sign"
                            />

                            <Input
                                label="Scheme Description"
                                name="scheme_description"
                                value={formData.scheme_description}
                                onChange={handleChange}

                                placeholder="Describe the scheme"
                                icon="feather-align-left"
                            />

                            <Input
                                label="Prepayment Allowed"
                                name="prepayment_allowed"
                                type="checkbox"
                                value={formData.prepayment_allowed}
                                onChange={handleChange}

                            />

                            <div className="mt-5 customButton">
                                <button type="submit" className="btn btn-lg btn-primary" disabled={isSubmitting}>
                                    {isSubmitting ? 'Submitting...' : id ? 'Update' : 'Submit'}
                                </button>
                            </div>
                        </form> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Loan_SchemesCreate;
